<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- APPLIED || ORDER DATE -->
        <Row type="flex" justify="space-between" class="code-row-bg">
          <Col :xs="24" :sm="24" :md="10">
            <FormItem prop="applied">
              <div class="switch-custom">
                <i-switch v-model="formData.applied"></i-switch>
                <span>{{schema.applied.label}}</span>
              </div>

            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="10">
            <FormItem
              prop="order_date"
              label-position="right"

            >
<!--              <template v-slot:label>-->
<!--                <span style="margin-left: 50px">{{-->
<!--                  schema.order_date.label-->
<!--                }}</span>-->
<!--              </template>-->

              <DatePicker
                :clearable="false"
                type="datetime"

                format="yyyy-MM-dd HH:mm"
                :value="formData.order_date"
                @on-change="setOrderDate"
                style="float: right"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>

        <!-- TYPE -->
        <FormItem prop="type" v-if="action === 'create' && isDebtRepayment === false">
          <RadioGroup
            v-model="formData.type"
            type="button"
            size="large"
            style="margin-bottom: 10px;"
          >
            <Radio label="coming"
              ><span style="margin: 0 15px"
                >Приход</span
              ></Radio
            >
            <Radio label="outgoing"
              ><span style="margin: 0 15px"
                >Расход</span
              ></Radio
            >

          </RadioGroup>
        </FormItem>

        <!-- NUMBER -->
        <FormItem :label="schema.number.label" prop="number" v-if="isDebtRepayment === false">
          <Input v-model="formData.number" :placeholder="schema.number.label" />
        </FormItem>

        <!-- CATEGORY -->
        <div v-if="action === 'create'">
          <!-- CATEGORY_OUTGOING-->
          <FormItem
            :label="schema.category.label"
            v-if="formData.type === 'outgoing'"
          >
            <Select v-model="formData.category" filterable>
              <Option
                v-for="item in formSelectOptions.category_outgoing"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- CATEGORY_COMING-->
          <FormItem
            :label="schema.category.label"
            v-if="formData.type === 'coming'"
          >
            <Select v-if="isDebtRepayment === false" v-model="formData.category" filterable>
              <Option
                v-for="item in formSelectOptions.category_coming"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
            <Select v-else v-model="formData.category" disabled filterable>
              <Option
                v-for="item in formSelectOptions.category_coming"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <!-- ACCOUNT -->
        <template v-if="action === 'create'">
          <FormItem v-if="isDebtRepayment === false"
            class="mb-30"
            :label="schema.account.label"
            prop="account"
            
          >
            <Select v-model="formData.account" filterable>
              <Option
                v-for="item in formSelectOptions.account"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem v-else
            class="mb-30"
            :label="cash_label"
            prop="cash"
            >
            <Select v-model="formData.cash" disabled filterable>
              <Option
                v-for="item in user_cashes"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </template>
        

        <div
          v-if="
            formData.category !== CORRECT_ACC_BALANCE && action === 'create'
          "
        >
          <!-- COUNTERPART TYPE -->
          <Divider v-if="isDebtRepayment === false"><h2>{{ counterpart_type }}</h2></Divider>
          <!-- COUNTERPART -->
          <Row :gutter="32">
            <Col span="24">
              <!-- TYPE -->
              <FormItem v-if="isDebtRepayment === false">
                <RadioGroup
                  v-model="formData.counterpart.type"
                  type="button"
                  class="d-flex"
                >
                  <Radio label="supplier">Поставщик</Radio>
                  <Radio label="customer">Покупатель</Radio>
                  <Radio label="user">Сотрудники</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem
                label="Контрагент"
                label-position="top"
                prop="counterpart.id"
                v-if="formData.counterpart.type === 'supplier'"
              >
                <Select v-model="formData.counterpart.id" filterable>
                  <Option
                    v-for="item in formSelectOptions.supplier"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem
                label="Контрагент"
                label-position="top"
                prop="counterpart.id"
                v-if="formData.counterpart.type === 'customer'"
              >
                <Select v-if="isDebtRepayment" v-model="formData.counterpart.id" disabled filterable>
                  <Option
                    v-for="item in formSelectOptions.customer"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
                <Select v-else v-model="formData.counterpart.id" filterable>
                  <Option
                    v-for="item in formSelectOptions.customer"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem
                label="Контрагент"
                label-position="top"
                prop="counterpart.id"
                v-if="formData.counterpart.type === 'user'"
              >
                <Select v-model="formData.counterpart.id" filterable>
                  <Option
                    v-for="item in formSelectOptions.user"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </div>
        <!-- <FormItem v-if="isDebtRepayment">
          <RadioGroup v-model="formData.payment_method" type="button" size="large">
            <Radio label="cash"><span style="margin: 0 15px">Наличные</span></Radio>
            <Radio label="card"><span style="margin: 0 15px">Карта</span></Radio>
            <Radio label="mobile"><span style="margin: 0 15px">Мобильные</span></Radio>
          </RadioGroup>
        </FormItem> -->
        <!-- SUM -->
        <FormItem v-if="isDebtRepayment === false" prop="sum" :label="schema.sum.label">
          <InputNumber
            :min="0"
            v-model="formData.sum"
            @input="validatePositive(formData.sum, 'sum', 'Сумма')" 
            :placeholder="schema.sum.label"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <template v-else>
          <FormItem prop="cashSum" label="Сумма наличными">
            <InputNumber 
              :min="0" 
              v-model="cashSum" 
              @input="validatePositive(cashSum, 'cashSum', 'Сумма наличными')" 
              style="width: 100%" />
          </FormItem>
          <FormItem prop="cardSum" label="Сумма картой">
            <InputNumber 
              :min="0" 
              v-model="cardSum" 
              @input="validatePositive(cardSum, 'cardSum', 'Сумма картой')" 
              style="width: 100%" />
          </FormItem>
          <FormItem prop="mobileSum" label="Сумма мобильными">
            <InputNumber 
              :min="0" 
              v-model="mobileSum" 
              @input="validatePositive(mobileSum, 'mobileSum', 'Сумма мобильными')" 
              style="width: 100%" />
          </FormItem>
        </template>

        <!-- DESCRIPTION -->
        <FormItem prop="description" :label="schema.description.label">
          <Input
            type="textarea"
            v-model="formData.description"
            :placeholder="schema.description.label"
          />
        </FormItem>
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()"><Icon type="md-close"/></Button>
      <Button
        type="info"
        @click="isDebtRepayment ? repaymentSave() : saveAction()"
        :disabled="canSave === false || disabledSaveButton"
        ><Icon type="md-checkmark"/>
      </Button>
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { base_url } from "../../http.js";
import { BaseFormData } from "../../base/base_form_v2.js";

// const CORRECT_ACC_BALANCE = 8;

let base = BaseFormData();

base.data = function() {
  return {
    loading: true,
    baseRules: {},
    isDebtRepayment: false,
    canSave: false,
    notificationIsShown: false,
    excludeFieldsRules: [],
    extraRules: {
      "counterpart.id": [
        {
          required: true,
          // type: "number",
          // message: this.schema[field].help_text,
          message: "Выберите корректное значение поля",
          trigger: "change"
        }
      ],
      "cash": [
        {
          required: true,
          // type: "number",
          // message: this.schema[field].help_text,
          message: "Выберите корректное значение поля",
          trigger: "change"
        }
      ]
    },
    validForm: false,
    isChanged: false,

    formData: {
      type: "",
      number: "",
      applied: "",
      sum: "",
      description: "",
      account: "",
      category: "",
      order_date: "",
      counterpart: {
        type: "",
        id: null
      }
    },

    formDefaultInitData: {
      type: "coming",
      number: "",
      applied: true,
      sum: 0,
      description: "",
      account: "",
      category: "",
      order_date: new Date(),
      counterpart: {
        type: "customer",
        id: null
      }
    },

    formSelectOptions: {
      account: [],
      supplier: [],
      customer: [],
      user: [],

      category_outgoing: [],
      category_coming: []
    },
    CORRECT_ACC_BALANCE: 8
  };
};
base.computed.counterpart_type = function() {
  return this.formData.type === "coming" ? "Отправитель" : "Получатель";
};
base.methods.checkCanSave = function() {
  // Проверяем значения полей и возвращаем true, если кнопка должна быть видима
  const cashSum = this.cashSum || 0;
  const cardSum = this.cardSum || 0;
  const mobileSum = this.mobileSum || 0;
  const sum = cashSum + cardSum + mobileSum;

  if (this.formData.is_debt_repayment) {
    return cashSum >= 0 && cardSum >= 0 && mobileSum >= 0 && sum > 0;
  }
  else {
    return this.formData.sum > 0
  }
};
base.methods.validatePositive = function(value, key, description) {
  if (value < 0) {
    // if (key === 'sum') {
    //   this.formData[key] = 0
    // }
    // else {
    //   this[key] = 0;
    // }
    if (this.notificationIsShown === false) {
      this.$Message.error(`${description} не может быть отрицательной.`);
      this.notificationIsShown = true;
    }
  }
  this.canSave = this.checkCanSave()
  if (this.canSave) {
    this.notificationIsShown = false;
  }
};
base.methods.setOrderDate = function(date_str, date2) {
  // console.log(date1);
  // console.log(date2);
  this.formData.order_date = date_str;
};

// Справочники
base.methods.getAccounts = function() {
  const url = base_url + "/options/accounts/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.account = result.data.results;
      if (this.isDebtRepayment) {
        this.formData.account = this.formSelectOptions.account[0].id // по умолчанию шлем первый
      }
    })

};
base.methods.getSuppliers = function() {
  const url = base_url + "/options/suppliers/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.supplier = result.data.results;
    })
};
base.methods.getCustomers = function() {
  const url = base_url + "/options/customers/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.customer = result.data.results;
    })
};
base.methods.getUsers = function() {
  const url = base_url + "/options/users/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.user = result.data.results;
    })
};
base.methods.getCategoryOutgoing = function() {
  const url = base_url + "/options/payment_category/outgoing/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.category_outgoing = result.data.results;
    })
};
base.methods.getCategoryComing = function() {
  const url = base_url + "/options/payment_category/coming/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.category_coming = result.data.results;

      if (this.isDebtRepayment) {
        this.formData.category = this.formSelectOptions.category_coming[this.formSelectOptions.category_coming.length - 1].id
      }
    })
};
base.methods.repaymentSave = function() {
    this.formData.payments = []
    this.formData.sum = 0
    
    if (this.cashSum > 0) {
        this.formData.payments.push({ payment_type: "CASH", sum: this.cashSum });
        this.formData.sum += this.cashSum
    }
    if (this.cardSum > 0) {
      this.formData.payments.push({ payment_type: "CARD", sum: this.cardSum });
      this.formData.sum += this.cardSum
    }
    if (this.mobileSum > 0) {
      this.formData.payments.push({ payment_type: "MOBILE", sum: this.mobileSum });
      this.formData.sum += this.mobileSum
    }
    this.saveAction()
    // this.$router.go(-1);
},
base.methods.setupFormData = function() {
  if (this.$route.query["type"] === "coming") {
    this.formData.type = "coming";
  } else if (this.$route.query["type"] === "outgoing") {
    this.formData.type = "outgoing";
  }
  if (this.$route.query["isDebtRepayment"]) {
    this.isDebtRepayment = this.$route.query["isDebtRepayment"]
  }

  if (this.isDebtRepayment) {
    if (this.$route.query["product_order"]) {
      this.formData.product_order = this.$route.query["product_order"]
    }
    if (this.$route.query["counterpart_id"]) {
      this.formData.counterpart.type = "customer"
      this.formData.counterpart.id = this.$route.query["counterpart_id"]
    }
    this.item_type = "debtor"
    this.formData.is_debt_repayment = this.isDebtRepayment
    this.formData.cash = this.$route.query["cash"]
    //this.formData.cash = ""
    this.user_cashes = this.cashes
    this.cashSum = 0
    this.cardSum = 0
    this.mobileSum = 0
    this.debtSum = this.$route.query["debt_sum"]
    this.cash_label = "Касса"
  }
}

base.mounted = function() {
  this.setupFormData();
  this.getAccounts();
  this.getSuppliers();
  this.getCustomers();
  this.getUsers();
  this.getCategoryOutgoing();
  this.getCategoryComing();
};

base.watch.type = function(to, from) {
  this.formData.category = "";
};

base.watch["formData.counterpart.id"] = function(to, from) {
  this.validateForm();
  this.isChanged = true;
};

base.watch["formData.cash"] = function(to, from) {
  this.validateForm();
  this.isChanged = true;
};

// base.watch['formData.account'] = function (to, from) {
//   console.log(11);
// };

export default base;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrderForm.vue